import {isDevMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {
    ASSIGNMENT_PLAYER,
    getPlayerName,
    HANDS_FREE_PLAYER,
    LIST_PLAYER,
    PRACTICE_PLAYER,
    REFRESH_PLAYER,
    STANDALONE_ACTIVITY_PLAYER,
    UNIT_PLAYER
} from './app/constants/player-names';
import {appConfig} from './app/player.config';

if (!isDevMode()) {
    const win: any = window;
    win.pushState = win.history.pushState = (state, unused, url) => {
    };
}
let compLoadPromise: Promise<any>;
const playerName = getPlayerName();
if (playerName === UNIT_PLAYER) {
    compLoadPromise = import('./app/views/unit-player/unit-player.component');
} else if (playerName === LIST_PLAYER) {
    compLoadPromise = import('./app/views/list-player/list-player.component');
} else if (playerName === PRACTICE_PLAYER) {
    compLoadPromise = import('./app/views/practice-player/practice-player.component');
} else if (playerName === REFRESH_PLAYER) {
    compLoadPromise = import('./app/views/refresh-player/refresh-player.component');
} else if (playerName === HANDS_FREE_PLAYER) {
    compLoadPromise = import('./app/views/hands-free-player/hands-free-player.component');
} else if (playerName === ASSIGNMENT_PLAYER) {
    compLoadPromise = import('./app/views/assignment-player/assignment-player.component.js');
} else if (playerName === STANDALONE_ACTIVITY_PLAYER) {
    compLoadPromise = import('./app/views/standalone-activity-player/standalone-activity-player.component');
}
compLoadPromise.then((cmp: any) => {
    const name = Object.keys(cmp).find(propName => propName.endsWith('Component'));
    bootstrapApplication(cmp[name], appConfig)
        .catch((err) => console.error(err));
}).catch((err) => console.error(err));
